import { Injectable } from '@angular/core';
import { User } from '../users/users.model';
import { CoursesService } from '../courses/courses.service';
import { map, Observable, of, switchMap } from 'rxjs';
import { ActivatedRouteSnapshot, DefaultUrlSerializer } from '@angular/router';
import { RequiredField, Requirements } from './requirements.model';
import { InvitesService } from '../invites/invites.service';


export function hasValidEmail(user:User, requirements:Requirements) {

  if (!requirements.emailSuffixes.length)
    return true ;

  for (let suffix of requirements.emailSuffixes) {
    if (user.email.toLowerCase().endsWith(suffix.toLowerCase())) {
      return true ;
    }
  }

  return false ;
}


export function getMissingFields(user: User, requirements:Requirements): RequiredField[] {

  let missingFields: RequiredField[] = [] ;

  if (requirements.fields.includes('BIO')) {
    if (!user.bio || user.bio.trim().length == 0) {
      missingFields.push('BIO') ;
    }
  }

  if (requirements.fields.includes('SELFIE')) {
    if (!user.profileImage) {
      missingFields.push('SELFIE');
    }
  }

  return missingFields ;

}

function getCourseId(returnUrl: string): string | undefined {

  const re = /\/courses?\/([a-zA-Z0-9]*)/;
  const match = re.exec(returnUrl);

  if (match)
    return match[1]
  else
    return undefined ;

}

function getInviteId(returnUrl: string): string | undefined {


  const re = /\/invites?\/([a-zA-Z0-9]*)/;
  const match = re.exec(returnUrl);

  console.log("getInviteId", returnUrl, match) ;

  if (match)
    return match[1]
  else
    return undefined ;

}


@Injectable({
  providedIn: 'root'
})
export class RequirementsService {

  constructor(
    private courses: CoursesService,
    private invites: InvitesService
  ) { }

  private getRequirementsFromCourseId(courseId: string): Observable<Requirements> {
      return this.courses.getCourse(courseId).pipe(
        map(result => {
            let requirements = result.requirements ;

            if (result.sandbox) {
              requirements.allowGuests = true ;
            }

            return requirements ;
          }
        )); 
  }

  private getRequirementsFromInviteId(inviteId: string): Observable<Requirements> {
    return this.invites.getInvite(inviteId).pipe(
      map(invite => {
        let requirements = invite.requirements ;

            if (invite.course.sandbox) {
              requirements.allowGuests = true ;
            }

            return requirements ;
      })
    );
  }

  getRequirementsFromRoute(route: ActivatedRouteSnapshot): Observable<Requirements>  {

    if (!route || !route.params) {
      return of(new Requirements());
    }

    if (!route.url[0] || route.url[0].path === 'admin') {
      return of(new Requirements());
    }

    const courseId = route.params['courseId'] ;
    const inviteId = route.params['inviteId'] ;

    try {
      if (courseId) 
        return this.getRequirementsFromCourseId(courseId) ;

      if (inviteId)
        return this.getRequirementsFromInviteId(inviteId) ;
    } catch (e) {
      console.error("Error getting requirements from route", e);
      return of(new Requirements()) ;
    }

    return of(new Requirements())
  }

  getRequirementsFromReturnUrl(returnUrl: string | undefined | null): Observable<Requirements> {

    if (!returnUrl) 
      return of(new Requirements())
    
    //ignore if returnUrl starts with /admin
    if (returnUrl.startsWith('/admin')) {
      return of(new Requirements());
    }

    const courseId = getCourseId(returnUrl);
    const inviteId = getInviteId(returnUrl);

    try {
      if (courseId)
        return this.getRequirementsFromCourseId(courseId);

      if (inviteId)
        return this.getRequirementsFromInviteId(inviteId);
    } catch (e) {
      console.error("Error getting requirements from return URL", e);
      return of(new Requirements());
    }

    return of(new Requirements())
  }

  getFieldName(field: RequiredField): string {
      switch (field) {
        case "BIO":
          return "bio";
        case "SELFIE":
          return "selfie" ;
      }
    }
  
    getFieldDescription(field: RequiredField): string {
      switch (field) {
        case "BIO":
          return "a sentence or so describing yourself, to break the ice";
        case "SELFIE":
          return "a recent photo of yourself, so people can recognize you" ;
      }
    }


}